import PasswordOptions from "./PasswordOptions";

export default PasswordOptions;
